import FormLabel, { formLabelClasses } from '@mui/material/FormLabel';
import { svgIconClasses } from '@mui/material/SvgIcon';
import { styled } from '@mui/material/styles';
import { CbridgePalette } from '@cbridge-utils/mui-theme';

// Shared field label: text first, then the required asterisk, then the tooltip icon.
export const FieldFormLabel = styled(FormLabel)({
  display: 'flex',
  alignItems: 'center',

  [`.${formLabelClasses.asterisk}`]: {
    order: 2,
    whiteSpace: 'noWrap',
  },

  [`.${svgIconClasses.root}`]: {
    order: 3,
    color: CbridgePalette.icon.secondary,
  },
});

export const FieldLabelText = styled('div')(({ theme }) => ({
  overflow: 'hidden',
  whiteSpace: 'nowrap',
  textOverflow: 'ellipsis',
  color: theme.palette.text.primary,
}));
